module.exports = __webpack_public_path__ + "static/media/app_store.e3bfa5d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/app_store.png
// module id = 291
// module chunks = 0